import { render, staticRenderFns } from "./VolvoDisclosure2024.vue?vue&type=template&id=7f7e177a&"
import script from "./VolvoDisclosure2024.vue?vue&type=script&lang=js&"
export * from "./VolvoDisclosure2024.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports